import { Link } from "react-router-dom";
import { type BetterHtmlProviderConfig } from "react-better-html";

import { contentMaxWidth, devMode, passwordMinLength } from "./app";
import { icons } from "./icons";
import { assets } from "./assets";

const labelColor = "#5a5548";

export const config: BetterHtmlProviderConfig = {
   devMode,
   app: {
      contentMaxWidth,
   },
   theme: {
      styles: {
         fontFamily: "Onest, sans-serif",
         borderRadius: 12,
         headerHeight: 80,
         boxShadow: "#1e1a141a 0px 20px 60px",
         boxShadow2: "#1e0a0f3d 0px 14px 32px",
      },
      colors: {
         light: {
            textPrimary: "#221f1c",
            textSecondary: "#8c8579",
            primary: "#fa354e",
            secondary: "#e4273f",
            three: "#c21f38",
            info: "#2e6bb0",
            success: "#72ba63",
            warn: "#e49e22",
            error: "#fa354e",
            backgroundBase: "#f9f7f2", // Dark -1
            backgroundSecondary: "#eceae6", // Dark -2
            backgroundThree: "#dad6cd", // Dark -3
            base: "#f9f7f2", // Dark -1
            border: "#f0ece4",
         },
      },
   },
   icons,
   assets,
   components: {
      button: {
         style: {
            default: {
               borderRadius: 999,
            },
            secondary: {
               borderRadius: 999,
            },
            destructive: {
               borderRadius: 999,
            },
            upload: {
               borderRadius: 999,
            },
         },
         tagReplacement: {
            linkComponent: Link,
         },
      },
      label: {
         style: {
            default: {
               color: labelColor,
            },
         },
      },
      inputField: {
         style: {
            default: {
               infoTextColor: labelColor + "80",
            },
            multiline: {
               infoTextColor: labelColor + "80",
            },
            email: {
               infoTextColor: labelColor + "80",
            },
            password: {
               minLength: passwordMinLength,
               infoTextColor: labelColor + "80",
            },
            search: {
               infoTextColor: labelColor + "80",
            },
            phoneNumber: {
               infoTextColor: labelColor + "80",
            },
            date: {
               infoTextColor: labelColor + "80",
            },
            dateTime: {
               infoTextColor: labelColor + "80",
            },
            time: {
               infoTextColor: labelColor + "80",
            },
            color: {
               infoTextColor: labelColor + "80",
            },
         },
      },
      chip: {
         style: {
            default: {
               borderRadius: 999,
            },
            colored: {
               borderRadius: 999,
            },
         },
      },
      form: {
         style: {
            default: {
               actionButtonsLocation: "left",
            },
         },
      },
      toggleInput: {
         style: {
            switch: {
               inactiveBackgroundColor: "#dad6cd",
            },
         },
      },
   },
};
